import { Component, OnInit } from '@angular/core';
import { UserService } from '../../services/user/user.service';
import { AppearanceService } from '../../services/appearance/appearance.service';
import { AlertController, ModalController } from '@ionic/angular';
import { RiskFormModel } from 'src/app/models/risk-form.model';
import { JobService } from 'src/app/services/job/job.service';
import { Constants } from 'src/app/constants/constants';
import { ClientService } from 'src/app/services/client/client.service';


@Component({
  selector: 'modal-risk-form',
  templateUrl: './modal-risk-form.component.html',
  styleUrls: ['./modal-risk-form.component.scss'],
})
export class ModalRiskFormComponent implements OnInit {

  jobUid: number;

  riskForm: RiskFormModel = null;
  updatedRiskForm: RiskFormModel = null;


  constructor(public appearanceService: AppearanceService, private alertController: AlertController,
   public jobService: JobService, public clientService: ClientService, public modalController: ModalController) {

  }


  ngOnInit() 
  {

  }


  ionViewWillEnter()
  {
    if (!this.riskForm)
    {
      this.modalController.dismiss(null, null, 'RiskFormModel');
    }

    this.updatedRiskForm = JSON.parse(JSON.stringify(this.riskForm));
  }


  ionViewWillLeave()
  {
    
  }


  closeModal(returnData = null)
  {
    if ((JSON.stringify(this.updatedRiskForm) != JSON.stringify(this.riskForm)))
    {
      this.askToSave();
    }
    else
    {
      this.modalController.dismiss(returnData, null, 'RiskFormModel');
    }
  }


  wasChangeMade(): boolean
  {
    if ((JSON.stringify(this.updatedRiskForm) != JSON.stringify(this.riskForm)))
    {
      return true;
    }

    return false;
  }


  async askToSave()
  {
    const alert = await this.alertController.create({
      header: 'Do you want to save your changes?',
      buttons: [
        {
          text: 'No',
          role: 'cancel',
          handler: () => {
            
            this.modalController.dismiss(null, null, 'RiskFormModel');
          },
        },
        {
          text: 'Yes',
          role: 'confirm',
          handler: (data) => {
            
            this.saveRiskForm();

          },
        },
      ],
    });

    await alert.present();
  }


  saveRiskForm()
  {
    var payload = {
      jobUid: this.jobService.getCurrentJobUid(),
      clientUid: this.clientService.getClientUid(),
      organisationUid: this.clientService.getOrganisationUid(),
      riskForm: this.updatedRiskForm
    }

    this.appearanceService.showLoading("Please wait...").then(() => {

      this.jobService.updateJobRiskForm(payload).subscribe(response => {

        this.appearanceService.dismissLoading();

        if (response.Success)
        {
          this.appearanceService.presentToast("Risk Form saved.", Constants.TOAST_SUCCESS);

          var returnData = { reload: true };

          this.jobService.currentJob.riskForm = this.updatedRiskForm;
          this.modalController.dismiss(returnData, null, 'RiskFormModel');
        }
        else
        {
          this.appearanceService.presentToast(response.Message, Constants.TOAST_ERROR);
        }
      },
      err => {

        this.appearanceService.dismissLoading();
        this.appearanceService.presentToast(err, Constants.TOAST_ERROR);

      });
    });
  }
}
